import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Card } from '@/common/components/Card/Card';
import { Heading } from '@/common/components/Heading/Heading';
import { IconBadge } from '@/common/components/IconBadge/IconBadge';
import { Stack } from '@/common/components/Stack/Stack';
import { IFamilyMember } from '@/common/integrations/menhir/employee/employee/employee.types';
import { getMemberIconByAge } from '@/common/utils/family-members';
import { styles } from './FamilyMemberCard.styles';

interface IFamilyMemberCardProps {
  child: IFamilyMember;
  onPress: () => void;
}

export const FamilyMemberCard = ({
  child,
  onPress,
}: IFamilyMemberCardProps) => {
  const { t } = useTranslation();

  return (
    <Card onPress={onPress}>
      <Stack align="center" justify="center" gap="md">
        <IconBadge
          icon={getMemberIconByAge(child.birthdate, 20)}
          ratio={56}
          backgroundColor="accentSecondary20"
        />
        <Stack align="center">
          <Heading level={5} className={styles.text}>
            {child.shortName}
          </Heading>
          <BodyText color="neutral20" size="sm" className={styles.text}>
            {t(`general.kinship.${child.type}`)}
          </BodyText>
        </Stack>
      </Stack>
    </Card>
  );
};
